import { QueryClient } from "@tanstack/react-query";

// QueryClientProvider と atomWithQuery(jotai-tanstack-query) で同じインスタンスを共有する
export const queryClient = new QueryClient({
  defaultOptions: {
    queries: {
      retry: false,
      refetchOnWindowFocus: false,
    },
  },
});
